import React, { useState } from 'react';
import { TextField } from '@shopify/polaris';
import kioLogo from '../assets/kio-logo.svg';

export const COUNTRIES = [
  { code: 'DZ', flag: '🇩🇿', dial: '+213' },
  { code: 'FR', flag: '🇫🇷', dial: '+33' },
  { code: 'TN', flag: '🇹🇳', dial: '+216' },
  { code: 'MA', flag: '🇲🇦', dial: '+212' },
  { code: 'LY', flag: '🇱🇾', dial: '+218' },
  { code: 'MR', flag: '🇲🇷', dial: '+222' },
  { code: 'EG', flag: '🇪🇬', dial: '+20' },
  { code: 'SA', flag: '🇸🇦', dial: '+966' },
  { code: 'AE', flag: '🇦🇪', dial: '+971' },
  { code: 'BE', flag: '🇧🇪', dial: '+32' },
  { code: 'DE', flag: '🇩🇪', dial: '+49' },
  { code: 'ES', flag: '🇪🇸', dial: '+34' },
  { code: 'GB', flag: '🇬🇧', dial: '+44' },
  { code: 'IT', flag: '🇮🇹', dial: '+39' },
  { code: 'CA', flag: '🇨🇦', dial: '+1' },
  { code: 'US', flag: '🇺🇸', dial: '+1 US' },
];

export const PhoneField = ({ label, dialCode, onDialChange, value, onChange, onBlur, placeholder, isRtl }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div>
      <label style={{ display: 'block', fontSize: '0.8125rem', fontWeight: 550, lineHeight: '1.25rem', color: '#303030', marginBottom: '0.25rem' }}>
        {label}
      </label>
      <div style={{
        display: 'flex', alignItems: 'stretch',
        border: focused ? '1px solid #005bd3' : '1px solid #8a8a8a',
        borderRadius: '0.5rem', background: '#fdfdfd', minHeight: '2.25rem',
        outline: focused ? '2px solid #005bd3' : 'none', outlineOffset: '0px',
        transition: 'border-color 0.1s, outline 0.1s', direction: 'ltr', overflow: 'hidden',
      }}>
        <select
          value={dialCode}
          onChange={e => onDialChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{ border: 'none', borderRight: '1px solid #e3e3e3', padding: '0 6px 0 10px', background: '#f6f6f7', fontSize: '0.8125rem', cursor: 'pointer', outline: 'none', flexShrink: 0, color: '#303030', fontFamily: 'inherit' }}
        >
          {COUNTRIES.map(c => (
            <option key={c.code} value={c.dial}>{c.flag} {c.dial}</option>
          ))}
        </select>
        <input
          type="tel"
          inputMode="numeric"
          className="kio-phone-input"
          value={value}
          onChange={e => {
            let v = e.target.value.replace(/[^0-9\s\-()]/g, '');
            if (v.startsWith('0')) v = v.slice(1);
            onChange(v);
          }}
          placeholder={placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => { setFocused(false); onBlur?.(); }}
          style={{ flex: 1, border: 'none', padding: '0 0.75rem', fontSize: '0.8125rem', outline: 'none', background: 'transparent', color: '#303030', fontFamily: 'inherit', minWidth: 0, textAlign: 'left' }}
        />
      </div>
    </div>
  );
};

export const SPINNER_CSS = `
  @keyframes kio-spin { to { transform: rotate(360deg); } }
  .kio-spinner {
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: kio-spin 0.65s linear infinite;
    flex-shrink: 0;
  }
  .kio-spinner-dark {
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 2px solid rgba(0,0,0,0.12);
    border-top-color: #374151;
    border-radius: 50%;
    animation: kio-spin 0.65s linear infinite;
    flex-shrink: 0;
  }
`;

export const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" style={{ flexShrink: 0 }}>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v8.51h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.14z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.97 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
  </svg>
);

export const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const EyeOffIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

export const GoogleBtn = ({ onClick, loading, children }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={loading}
    aria-busy={loading}
    style={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10,
      padding: '10px 16px',
      border: '1.5px solid #e5e7eb',
      borderRadius: 8,
      background: '#fff',
      cursor: loading ? 'not-allowed' : 'pointer',
      fontSize: 14,
      fontWeight: 500,
      color: '#374151',
      boxSizing: 'border-box',
      opacity: loading ? 0.75 : 1,
    }}
    onMouseEnter={e => { if (!loading) { e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#d1d5db'; } }}
    onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#e5e7eb'; }}
  >
    {loading ? <span className="kio-spinner-dark" /> : <GoogleIcon />}
    {children}
  </button>
);

export const BlackBtn = ({ onClick, loading, children, fullWidth = true }) => (
  <button
    onClick={onClick}
    disabled={loading}
    aria-busy={loading}
    style={{
      width: fullWidth ? '100%' : undefined,
      padding: '11px 20px',
      background: loading ? '#555' : '#111',
      color: '#fff',
      border: 'none',
      borderRadius: 8,
      fontSize: 15,
      fontWeight: 600,
      cursor: loading ? 'not-allowed' : 'pointer',
      letterSpacing: 0.2,
      transition: 'background 0.15s',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
    }}
    onMouseEnter={e => { if (!loading) e.currentTarget.style.background = '#333'; }}
    onMouseLeave={e => { if (!loading) e.currentTarget.style.background = loading ? '#555' : '#111'; }}
  >
    {loading && <span className="kio-spinner" />}
    {children}
  </button>
);

export const LangSwitcher = ({ lang, setLang, light }) => (
  <div style={{ display: 'flex', gap: 6 }} role="group" aria-label="Language selector">
    {[['en', 'EN'], ['fr', 'FR'], ['ar', 'عر']].map(([l, label]) => (
      <button
        key={l}
        onClick={() => setLang(l)}
        aria-label={`Switch to ${l === 'en' ? 'English' : l === 'fr' ? 'French' : 'Arabic'}`}
        aria-pressed={lang === l}
        style={{
          padding: '3px 13px',
          borderRadius: 20,
          border: '1.5px solid',
          borderColor: lang === l
            ? (light ? 'rgba(255,255,255,0.9)' : '#111')
            : (light ? 'rgba(255,255,255,0.35)' : '#d1d5db'),
          background: lang === l
            ? (light ? 'rgba(255,255,255,0.18)' : '#111')
            : 'transparent',
          color: lang === l ? '#fff' : (light ? 'rgba(255,255,255,0.65)' : '#6b7280'),
          fontWeight: 600,
          fontSize: 12,
          cursor: 'pointer',
          transition: 'all 0.15s',
        }}
      >
        {label}
      </button>
    ))}
  </div>
);

export function PasswordField({ label, value, onChange, placeholder, helpText, autoComplete = 'off', disabled }) {
  const [show, setShow] = useState(false);
  return (
    <TextField
      label={label}
      type={show ? 'text' : 'password'}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
      placeholder={placeholder || '••••••••'}
      helpText={helpText}
      disabled={disabled}
      suffix={
        <button
          type="button"
          onClick={() => setShow(p => !p)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#fff', padding: '0 2px', display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 500 }}
        >
          {show ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      }
    />
  );
}

export const AuthLeftPanel = ({ lang, setLang, isRtl, tagline }) => (
  <div style={{
    width: '50%',
    height: '100vh',
    background: '#111',
    backgroundImage: 'url(https://cdn.kiostore.net/file/kiostore/aadl3/bea3ad90-d9bc-4bb2-a316-52d4eba5d720_Chemise-Velour-10.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '36px 40px',
    position: 'relative',
    overflow: 'hidden',
    flexShrink: 0,
  }}>
    <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(170deg, rgba(0,0,0,0.48) 0%, rgba(0,0,0,0.28) 100%)' }} />

    {/* Spacer top */}
    <div style={{ position: 'relative' }} />

    {/* Tagline card */}
    <div style={{
      position: 'relative',
      background: 'rgba(255,255,255,0.6)',
      backdropFilter: 'blur(12px)',
      borderRadius: 16,
      padding: '24px 28px',
      border: '1px solid rgba(255,255,255,0.5)',
      direction: 'ltr',
    }}>
      <p style={{ color: 'rgba(0,0,0,0.5)', fontSize: 12, fontWeight: 600, letterSpacing: 1.5, textTransform: 'uppercase', margin: '0 0 10px 0' }}>
        KIO · Algeria
      </p>
      {tagline.split('\n').map((line, i) => (
        <p key={i} style={{
          color: '#111',
          fontSize: i === 0 ? 15 : 28,
          fontWeight: i === 0 ? 400 : 800,
          lineHeight: i === 0 ? 1.5 : 1.2,
          margin: i === 0 ? '0 0 4px 0' : 0,
          letterSpacing: i === 1 ? -0.5 : 0,
        }}>
          {line}
        </p>
      ))}
    </div>

    {/* Lang switcher */}
    <div style={{ position: 'relative' }}>
      <LangSwitcher lang={lang} setLang={setLang} light />
    </div>
  </div>
);
